// extracted by mini-css-extract-plugin
module.exports = {"container":"Policy_container_2mEIZ","backButton":"Policy_backButton_3rOEN"};